import { render, staticRenderFns } from "./TotalBalance.vue?vue&type=template&id=f7836bcc&scoped=true&"
import script from "./TotalBalance.vue?vue&type=script&lang=js&"
export * from "./TotalBalance.vue?vue&type=script&lang=js&"
import style0 from "./TotalBalance.vue?vue&type=style&index=0&id=f7836bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7836bcc",
  null
  
)

export default component.exports